import { useTranslation } from "react-i18next";
import { IgAuthMethod } from "../api/types";

interface Props {
  method: IgAuthMethod;
}

/**
 * Collapsible "where do I find this?" / "how does this work?" help block,
 * shared between the Add Instagram Account flow and the Edit Account modal so
 * the step-by-step instructions stay in one place.
 */
export default function AuthMethodHelp({ method }: Props) {
  const { t } = useTranslation();
  const ns = `authMethodHelp.${method}`;

  // We hand-list step keys so the i18n side stays plain string-only (no
  // returnObjects/array tricks) and the catalogs stay easy to diff per language.
  const stepKeys: Record<IgAuthMethod, string[]> = {
    interactive: ["s1", "s2", "s3", "s4", "s5"],
    backup_codes: ["s1", "s2", "s3", "s4", "s5"],
    totp: ["s1", "s2", "s3", "s4", "s5", "s6"],
  };

  return (
    <details className="mt-2 rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2 text-xs text-slate-300">
      <summary className="cursor-pointer select-none font-medium text-slate-200 hover:text-white">
        {t(`${ns}.toggle`)}
      </summary>
      <ol className="mt-2 list-decimal space-y-1 pl-5 text-slate-300">
        {stepKeys[method].map((key) => (
          <li key={key}>{t(`${ns}.steps.${key}`)}</li>
        ))}
      </ol>
      <p className="mt-2 text-[11px] text-slate-400">{t(`${ns}.note`)}</p>
    </details>
  );
}
